import "react";

declare module 'react' {
  interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
    // extends React's HTMLAttributes so we can pass our custom elements.
    'data-cy'?: string;
  }
}
